import React, { Component } from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';
import settings from '../../utils/settings';

const styles = theme => ({
  loggedInBanner: {
    justifyContent: 'center',
    borderRadius: 0,
    marginTop: theme.spacing(0.1),
    alignItems: 'center',
    background: '#ADD163 !important',
    color: 'black',
    padding: theme.spacing(0, 2)
  },
  alertBox: {
    display: 'flex',
    alignItems: 'center'
  },
  alertButton: {
    marginLeft: `${theme.spacing(1)}px !important`,
    color: 'green !important',
    boxShadow: 'none !important',
    border: '1px solid !important'
  }
});

class LoggedAs extends Component {
  handleStopButton() {
    const loggedOutAs = settings.enlightenMenuUrl('logout_as');
    window.location.replace(loggedOutAs);
  }

  render() {
    const { accountDetail, classes } = this.props;
    if (!accountDetail.login_as) return null;
    const { login_user_detail } = accountDetail;
    return (
      <Alert icon={false} severity="success" elevation={6} variant="filled" className={classes.loggedInBanner}>
        <Box className={classes.alertBox}>
          <Typography>{login_user_detail}</Typography>
          <Button
            variant="contained"
            color="default"
            size="small"
            className={classes.alertButton}
            onClick={() => this.handleStopButton()}
          >
            Stop
          </Button>
        </Box>
      </Alert>
    );
  }
}

export default withStyles(styles)(LoggedAs);
